<section>
    <table mat-table [dataSource]="dataSource" class="w-100">
        <caption>Request info</caption>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                <div [ngSwitch]="element.status">
                    <div *ngSwitchCase="'rejected'" class="status status-error justify-content-center d-flex align-items-center me-2" placement="top">
                        <fa-icon [icon]="faXmark">{{element.status}}</fa-icon>
                    </div>
                    <div *ngSwitchCase="'success'" class="status status-success justify-content-center d-flex align-items-center me-2" placement="top">
                        <fa-icon [icon]="faCheck">{{element.status}}</fa-icon>
                    </div>
                    <div *ngSwitchDefault class="justify-content-center d-flex align-items-center me-2" placement="top">
                    </div>
                </div>
            </td>
        </ng-container>


        <!-- Date Column -->
        <ng-container matColumnDef="date">
            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'HISTORY_REQUEST_INFO.DATE' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.date}}
            </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                {{'HISTORY_REQUEST_INFO.ACTION' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.action}} </td>
        </ng-container>

        <!-- Author Column -->
        <ng-container matColumnDef="userEmail">
            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'HISTORY_REQUEST_INFO.AUTHOR' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.userEmail}} </td>
        </ng-container>

        <!-- Comment Column -->
        <ng-container matColumnDef="comment">
            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                {{'HISTORY_REQUEST_INFO.COMMENT' | translate}}
            </th>
            <td mat-cell *matCellDef="let element" class="nv-note-column">
                <div class="comment-container">
                    {{element.comment}}
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsRequest; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsRequest;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">{{'NO_RESULT' | translate}}</td>
        </tr>
    </table>
</section>